import { Button, TextField } from '@statsbomb/kitbag-components';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { styled } from 'styled-components';
import themeHelper from '../../utils/themeHelper';

const Container = styled.div`
  display: flex;
  gap: ${themeHelper.spacing()};
`;

export function EventSearchBox({ isPending, setEvents }) {
  const intl = useIntl();

  const [eventString, setEventString] = useState();

  const submit = () => {
    setEvents(eventString?.toString()?.replaceAll(' ', '').split(','));
  };

  return (
    <Container>
      <TextField
        id="events-lookup"
        onChange={(event) => setEventString(event.target.value)}
        placeholder={intl.formatMessage({
          defaultMessage: 'Comma separated list of events',
          id: '30628',
        })}
        value={eventString}
        variant="secondary"
      />
      <Button onClick={submit} isPending={isPending}>
        <FormattedMessage defaultMessage="Submit" id="a4d3b" />
      </Button>
    </Container>
  );
}

EventSearchBox.propTypes = {
  isPending: PropTypes.bool,
  setEvents: PropTypes.func.isRequired,
};
EventSearchBox.defaultProps = {
  isPending: false,
};

export default { EventSearchBox };
